var map = {
	"./About.png": 65237,
	"./Blog.png": 49556,
	"./Book.png": 33909,
	"./Class.png": 74883,
	"./Coin.png": 64817,
	"./Computer.png": 23707,
	"./Dashboard.png": 68830,
	"./Glasses.png": 65318,
	"./Graduate.png": 22769,
	"./History.png": 31319,
	"./Management.png": 92810,
	"./Notif.png": 49549,
	"./Partner.png": 83366,
	"./Payment.png": 49526,
	"./People.png": 22813,
	"./Setting.png": 46569,
	"./Star.png": 97708,
	"./backup.svg": 81929,
	"./class.svg": 8013,
	"./cms.svg": 76511,
	"./dashboard.svg": 56177,
	"./event.png": 57170,
	"./expense.png": 24359,
	"./income.png": 2779,
	"./insight.svg": 41997,
	"./newsletter.svg": 94280,
	"./partner.svg": 36057,
	"./payment.svg": 91693,
	"./product.png": 86836,
	"./profit.png": 53533,
	"./referral.svg": 27538,
	"./schedule.png": 34885,
	"./settings.svg": 52268,
	"./transaction.png": 73133,
	"./user.svg": 37212,
	"./workshop.svg": 58738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39686;